import { ITrainPolicy } from '@/models/Train/interfaces/ITrainPolicy';

/**
 * 기차 정책
 */
export const trainPolicy: ITrainPolicy = Object.freeze({
  duration: 'P31D',
  lastOrders: '02:00',
  lastOrder: {
    days: 2,
    time: '02:00',
  },
  passengerCapacity: {
    min: 1,
    max: 9,
  },
  directOrder: false,
});
